import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { IFields } from 'CMFW/grid/fields';
import { ItemSourceGuesserModel } from 'models/ItemSourceGuesserModel';
import ItemSourceGuesserDetails from '../components/ItemSourceGuesserDetails';
import ItemSourceGuesserCreate from '../components/ItemSourceGuesserCreate';
import { conceptValidatorStatusRenderer } from '../../../CMFW/grid/cellRenderers/conceptValidatorStatus';

export type IProps = {
  courseId: number;
};

const ItemSourceGuesser: React.FC<IProps> = ({ courseId }) => {
  const forceRender = useForceRender();
  const [showCreate, setShowCreate] = useState(false);

  const model = useMemo(() => new ItemSourceGuesserModel({ render: forceRender, courseId }), [forceRender, courseId]);

  const handleNewClick = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);

  const handleCreateSuccess = async (jobId: number) => {
    setShowCreate(false);
    await model.loadItemEdit(jobId);
  };

  const cellRenderers = useMemo(
    () => ({
      [IFields.itemSourceGuesserStatus]: conceptValidatorStatusRenderer,
    }),
    [],
  );
  return (
    <ModuleContainer>
      <ModuleContext.Provider value={model}>
        <Split widthLeft={432}>
          <ContainerLeft>
            <Grid cellRenderers={cellRenderers} />
            <ContainerLeftFooter>
              <ReloadButton />
              <Button variant="outlined" onClick={handleNewClick} size="small">
                new
              </Button>
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            {showCreate ? (
              <ItemSourceGuesserCreate model={model} onClose={handleCreateClose} onSuccess={handleCreateSuccess} />
            ) : model.itemId ? (
              <ItemSourceGuesserDetails />
            ) : (
              <EmptyState>
                <EmptyStateText>Select a job from the list or create a new one</EmptyStateText>
              </EmptyState>
            )}
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default ItemSourceGuesser;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #666;
`;

const EmptyStateText = styled.div`
  text-align: center;
  font-size: 16px;
`;
